<template id="warp_sim12">
    <div class="content1" style="font-size: 0.8rem;padding-bottom: 4rem;">
			<div style="margin: 1rem;border: 1px solid #ededed;">
				<div class="content-top" style="background-color:#fafafa;">
					<span style="width:50%">中文名稱 
						<span style="margin-left: 6%;">{{params.cn_name}}</span>
					</span>
					<span style="width:50%;display:flex;">
						<div style="flex-shrink: 0;">英文名稱</div>
						<span style="margin-left: 6%;display:flex;align-items:center ;line-height: normal;">{{params.en_name}}</span>
					</span>
				</div>
				<div class="content-top">
					<span style="width:50%">電話號碼 
						<span style="margin-left: 6%;"><span v-if="params.nationcode">+</span>{{params.nationcode}}{{params.phonenum}}</span>
					</span>
					<span style="width:50%;display:flex;">
						<div style="flex-shrink: 0;">電郵地址</div>
						<div :title="params.email" style="margin-left: 6%;display:flex;align-items:center ;line-height: normal;">{{params.email}}</div>
					</span>
				</div>
				<div class="content-top" style="background-color:#fafafa;">
					<span style="width:50%">身份信息 
						<span style="margin-left: 6%;">{{params.id_number}}</span>
					</span>
					<span style="width:50%">出生日期 
						<span style="margin-left: 6%;">{{params.birth}}</span>
					</span>
				</div>
				<div class="content-top">
					<span style="width:50%">銀行名稱 
						<span style="margin-left: 6%;">{{params.bank}}</span>
					</span>
					<span style="width:50%">銀行號碼 
						<span style="margin-left: 6%;">{{params.bank_number}}</span>
					</span>
				</div>
				<div class="content-top" style="background-color:#fafafa;">
					<span style="width:100%">地址信息 
						<span style="margin-left: 3%;">{{params.address}}</span>
					</span>
				</div>
			</div>
    </div>
</template>

<script>
import App from '@/assets/app.js';
export default {
  props: ["items"],
  data() {
    return {
			params:{},
    };
  },
  mounted() {
		console.log(this.items);
		this.echoData();
  },
  methods: {
		echoData(){
			this.$ajax({
				method: "post",
				url: this.$api.getQmisUserMsgWithUsername,
				data: {
					username:this.items.username,
				},
			}).then((res) => {
				if (res.data.qmiscode == 1000) {
					this.params = res.data;
				} else {
					App.oTool.warningT(res.data.qmismsg);
				}
			});
		},

  },
};
</script>

<style lang="scss" scoped>
	.content1{
		padding-bottom: 1rem;
		border-radius: 0 0 10px 10px;
		padding: 1rem;
		background-color: #fff;
		margin-bottom: 1rem;
		min-height: 50px;
	}
	.content-top{
		width: 100%;
		height: 3.1rem;
		background: #ffffff;
		color: #000000;
		line-height: 3.1rem;
		display: flex;
		padding: 0 20px;
	}
</style>
